import React from 'react';
import { Input } from 'antd';
import FormItem from './FormItem';
import NotEditableItem from './NotEditableItem';

export default function FormTextArea({ editable, name, value, error, onChange, layout, label, required, ...props }) {
  if (!editable) {
    return (
      <NotEditableItem title={props.placeholder} value={value} />
    );
  }

  return (
    <FormItem
      label={label}
      required={required}
      error={error}
      layout={layout}
    >
      <Input.TextArea
        autoComplete="off"
        name={name}
        value={value}
        onChange={onChange}
        defaultValue=""
        {...props}
      />
    </FormItem>
  );
}



// WEBPACK FOOTER //
// ./src/components/BaseForm/components/TextArea.js